/**
 * flt_productsreviews — entrée principale (→ views/js/flt_reviews.js)
 * Charge dynamiquement le module JS du thème actif via data-theme.
 */

type ThemeSlug = 'menhir' | 'caribou-catalog' | 'caribou-store';

document.addEventListener('DOMContentLoaded', () => {
  loadTheme();
  initStandaloneForm();
});

async function loadTheme(): Promise<void> {
  const wrapper = document.querySelector<HTMLElement>('.flt-reviews-wrapper');
  const theme = (wrapper?.dataset.theme ?? 'menhir') as ThemeSlug;

  const themeModules: Record<ThemeSlug, () => Promise<{ init: () => void }>> = {
    'menhir':          () => import('./themes/menhir'),
    'caribou-catalog': () => import('./themes/caribou-catalog'),
    'caribou-store':   () => import('./themes/caribou-store'),
  };

  const loader = themeModules[theme] ?? themeModules['menhir'];
  const mod = await loader();
  mod.init();
}

/** Initialise les étoiles + compteur + dropzone photo sur la page formulaire standalone (token email). */
async function initStandaloneForm(): Promise<void> {
  const form = document.querySelector<HTMLFormElement>('.flt-reviews-form, .flt-reviews-form--order');
  if (!form) return;

  const [{ initAll: initStars }, { init: initCounter }, { initDropzone }] = await Promise.all([
    import('./molecules/star-input'),
    import('./molecules/char-counter'),
    import('./molecules/photo-upload'),
  ]);

  initStars(form);
  initDropzone(form);

  form.querySelectorAll<HTMLTextAreaElement>('textarea[maxlength]').forEach(ta => {
    const counter = ta.parentElement?.querySelector<HTMLElement>('[id$="-char-count"], .flt-reviews-order-char-count');
    if (counter) initCounter(ta, counter);
  });
}
